import axios from 'axios'

const emailValidationApi = axios.create({
	baseURL: `https://emailvalidation.abstractapi.com/v1`,
})

export default emailValidationApi
